import p1 from 'src/assets/img/about/p1.jpg';
import p3 from 'src/assets/img/about/p3.jpg';
import p4 from 'src/assets/img/about/p4.jpg';
import p6 from 'src/assets/img/about/p6.jpg';
import flow5 from 'src/assets/img/about/flow5.jpg';
import flow4 from 'src/assets/img/about/flow4.jpg';
import flow7 from 'src/assets/img/about/flow7.jpg';
import flow6 from 'src/assets/img/about/flow6.jpg';

const Content = () => {
  return (
    <>
      <section class='pt-20 lg:pt-[120px] pb-12 lg:pb-[90px] overflow-hidden bg-white justify-center flex'>
        <div class='container'>
          <div class='flex flex-wrap justify-between items-center -mx-4'>
            <div class='w-full lg:w-6/12 px-4'>
              <div class='flex items-center -mx-3 sm:-mx-4 '>
                <div class='w-full xl:w-1/2 px-3 sm:px-4 '>
                  <div class='rounded-2xl py-3 sm:py-4 ' data-aos='flip-right'>
                    <img
                      src={p1}
                      alt=''
                      class='rounded-2xl w-full hover:shadow-lg hover:shadow-blue-500/50'
                    />
                  </div>
                  <div class='py-3 sm:py-4' data-aos='flip-up'>
                    <img
                      src={p3}
                      alt=''
                      class='rounded-2xl w-full hover:shadow-lg hover:shadow-blue-500/50'
                    />
                  </div>
                </div>
                <div class='w-full xl:w-1/2 px-3 sm:px-4' data-aos='flip-left'>
                  <div class='my-4 relative z-10'>
                    <img
                      src={p4}
                      alt=''
                      class='rounded-2xl w-full hover:shadow-lg hover:shadow-blue-500/50'
                    />
                    <span class='absolute -right-7 -bottom-7 z-[-1]'>
                      <svg
                        width='134'
                        height='106'
                        viewBox='0 0 134 106'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <circle
                          cx='1.66667'
                          cy='104'
                          r='1.66667'
                          transform='rotate(-90 1.66667 104)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='16.3333'
                          cy='104'
                          r='1.66667'
                          transform='rotate(-90 16.3333 104)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='31'
                          cy='104'
                          r='1.66667'
                          transform='rotate(-90 31 104)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='45.6667'
                          cy='104'
                          r='1.66667'
                          transform='rotate(-90 45.6667 104)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='60.3334'
                          cy='104'
                          r='1.66667'
                          transform='rotate(-90 60.3334 104)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='88.6667'
                          cy='104'
                          r='1.66667'
                          transform='rotate(-90 88.6667 104)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='117.667'
                          cy='104'
                          r='1.66667'
                          transform='rotate(-90 117.667 104)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='74.6667'
                          cy='104'
                          r='1.66667'
                          transform='rotate(-90 74.6667 104)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='103'
                          cy='104'
                          r='1.66667'
                          transform='rotate(-90 103 104)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='132'
                          cy='104'
                          r='1.66667'
                          transform='rotate(-90 132 104)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='1.66667'
                          cy='89.3333'
                          r='1.66667'
                          transform='rotate(-90 1.66667 89.3333)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='16.3333'
                          cy='89.3333'
                          r='1.66667'
                          transform='rotate(-90 16.3333 89.3333)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='31'
                          cy='89.3333'
                          r='1.66667'
                          transform='rotate(-90 31 89.3333)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='45.6667'
                          cy='89.3333'
                          r='1.66667'
                          transform='rotate(-90 45.6667 89.3333)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='60.3333'
                          cy='89.3338'
                          r='1.66667'
                          transform='rotate(-90 60.3333 89.3338)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='88.6667'
                          cy='89.3338'
                          r='1.66667'
                          transform='rotate(-90 88.6667 89.3338)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='117.667'
                          cy='89.3338'
                          r='1.66667'
                          transform='rotate(-90 117.667 89.3338)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='74.6667'
                          cy='89.3338'
                          r='1.66667'
                          transform='rotate(-90 74.6667 89.3338)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='103'
                          cy='89.3338'
                          r='1.66667'
                          transform='rotate(-90 103 89.3338)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='132'
                          cy='89.3338'
                          r='1.66667'
                          transform='rotate(-90 132 89.3338)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='1.66667'
                          cy='74.6673'
                          r='1.66667'
                          transform='rotate(-90 1.66667 74.6673)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='1.66667'
                          cy='31.0003'
                          r='1.66667'
                          transform='rotate(-90 1.66667 31.0003)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='16.3333'
                          cy='74.6668'
                          r='1.66667'
                          transform='rotate(-90 16.3333 74.6668)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='16.3333'
                          cy='31.0003'
                          r='1.66667'
                          transform='rotate(-90 16.3333 31.0003)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='31'
                          cy='74.6668'
                          r='1.66667'
                          transform='rotate(-90 31 74.6668)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='31'
                          cy='31.0003'
                          r='1.66667'
                          transform='rotate(-90 31 31.0003)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='45.6667'
                          cy='74.6668'
                          r='1.66667'
                          transform='rotate(-90 45.6667 74.6668)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='45.6667'
                          cy='31.0003'
                          r='1.66667'
                          transform='rotate(-90 45.6667 31.0003)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='60.3333'
                          cy='74.6668'
                          r='1.66667'
                          transform='rotate(-90 60.3333 74.6668)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='60.3333'
                          cy='30.9998'
                          r='1.66667'
                          transform='rotate(-90 60.3333 30.9998)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='88.6667'
                          cy='74.6668'
                          r='1.66667'
                          transform='rotate(-90 88.6667 74.6668)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='88.6667'
                          cy='30.9998'
                          r='1.66667'
                          transform='rotate(-90 88.6667 30.9998)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='117.667'
                          cy='74.6668'
                          r='1.66667'
                          transform='rotate(-90 117.667 74.6668)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='117.667'
                          cy='30.9998'
                          r='1.66667'
                          transform='rotate(-90 117.667 30.9998)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='74.6667'
                          cy='74.6668'
                          r='1.66667'
                          transform='rotate(-90 74.6667 74.6668)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='74.6667'
                          cy='30.9998'
                          r='1.66667'
                          transform='rotate(-90 74.6667 30.9998)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='103'
                          cy='74.6668'
                          r='1.66667'
                          transform='rotate(-90 103 74.6668)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='103'
                          cy='30.9998'
                          r='1.66667'
                          transform='rotate(-90 103 30.9998)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='132'
                          cy='74.6668'
                          r='1.66667'
                          transform='rotate(-90 132 74.6668)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='132'
                          cy='30.9998'
                          r='1.66667'
                          transform='rotate(-90 132 30.9998)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='1.66667'
                          cy='60.0003'
                          r='1.66667'
                          transform='rotate(-90 1.66667 60.0003)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='1.66667'
                          cy='16.3333'
                          r='1.66667'
                          transform='rotate(-90 1.66667 16.3333)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='16.3333'
                          cy='60.0003'
                          r='1.66667'
                          transform='rotate(-90 16.3333 60.0003)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='16.3333'
                          cy='16.3333'
                          r='1.66667'
                          transform='rotate(-90 16.3333 16.3333)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='31'
                          cy='60.0003'
                          r='1.66667'
                          transform='rotate(-90 31 60.0003)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='31'
                          cy='16.3333'
                          r='1.66667'
                          transform='rotate(-90 31 16.3333)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='45.6667'
                          cy='60.0003'
                          r='1.66667'
                          transform='rotate(-90 45.6667 60.0003)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='45.6667'
                          cy='16.3333'
                          r='1.66667'
                          transform='rotate(-90 45.6667 16.3333)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='60.3333'
                          cy='60.0003'
                          r='1.66667'
                          transform='rotate(-90 60.3333 60.0003)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='60.3333'
                          cy='16.3333'
                          r='1.66667'
                          transform='rotate(-90 60.3333 16.3333)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='88.6667'
                          cy='60.0003'
                          r='1.66667'
                          transform='rotate(-90 88.6667 60.0003)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='88.6667'
                          cy='16.3333'
                          r='1.66667'
                          transform='rotate(-90 88.6667 16.3333)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='117.667'
                          cy='60.0003'
                          r='1.66667'
                          transform='rotate(-90 117.667 60.0003)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='117.667'
                          cy='16.3333'
                          r='1.66667'
                          transform='rotate(-90 117.667 16.3333)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='74.6667'
                          cy='60.0003'
                          r='1.66667'
                          transform='rotate(-90 74.6667 60.0003)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='74.6667'
                          cy='16.3333'
                          r='1.66667'
                          transform='rotate(-90 74.6667 16.3333)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='103'
                          cy='60.0003'
                          r='1.66667'
                          transform='rotate(-90 103 60.0003)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='103'
                          cy='16.3333'
                          r='1.66667'
                          transform='rotate(-90 103 16.3333)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='132'
                          cy='60.0003'
                          r='1.66667'
                          transform='rotate(-90 132 60.0003)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='132'
                          cy='16.3333'
                          r='1.66667'
                          transform='rotate(-90 132 16.3333)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='1.66667'
                          cy='45.3333'
                          r='1.66667'
                          transform='rotate(-90 1.66667 45.3333)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='1.66667'
                          cy='1.66683'
                          r='1.66667'
                          transform='rotate(-90 1.66667 1.66683)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='16.3333'
                          cy='45.3333'
                          r='1.66667'
                          transform='rotate(-90 16.3333 45.3333)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='16.3333'
                          cy='1.66683'
                          r='1.66667'
                          transform='rotate(-90 16.3333 1.66683)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='31'
                          cy='45.3333'
                          r='1.66667'
                          transform='rotate(-90 31 45.3333)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='31'
                          cy='1.66683'
                          r='1.66667'
                          transform='rotate(-90 31 1.66683)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='45.6667'
                          cy='45.3333'
                          r='1.66667'
                          transform='rotate(-90 45.6667 45.3333)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='45.6667'
                          cy='1.66683'
                          r='1.66667'
                          transform='rotate(-90 45.6667 1.66683)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='60.3333'
                          cy='45.3338'
                          r='1.66667'
                          transform='rotate(-90 60.3333 45.3338)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='60.3333'
                          cy='1.66683'
                          r='1.66667'
                          transform='rotate(-90 60.3333 1.66683)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='88.6667'
                          cy='45.3338'
                          r='1.66667'
                          transform='rotate(-90 88.6667 45.3338)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='88.6667'
                          cy='1.66683'
                          r='1.66667'
                          transform='rotate(-90 88.6667 1.66683)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='117.667'
                          cy='45.3338'
                          r='1.66667'
                          transform='rotate(-90 117.667 45.3338)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='117.667'
                          cy='1.66683'
                          r='1.66667'
                          transform='rotate(-90 117.667 1.66683)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='74.6667'
                          cy='45.3338'
                          r='1.66667'
                          transform='rotate(-90 74.6667 45.3338)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='74.6667'
                          cy='1.66683'
                          r='1.66667'
                          transform='rotate(-90 74.6667 1.66683)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='103'
                          cy='45.3338'
                          r='1.66667'
                          transform='rotate(-90 103 45.3338)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='103'
                          cy='1.66683'
                          r='1.66667'
                          transform='rotate(-90 103 1.66683)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='132'
                          cy='45.3338'
                          r='1.66667'
                          transform='rotate(-90 132 45.3338)'
                          fill='#3056D3'
                        />
                        <circle
                          cx='132'
                          cy='1.66683'
                          r='1.66667'
                          transform='rotate(-90 132 1.66683)'
                          fill='#3056D3'
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class='w-full lg:w-1/2 xl:w-5/12 px-4'>
              <div class='mt-10 lg:mt-0' data-aos='fade-left'>
                <span class='font-semibold text-lg text-primary mb-2 block'>
                  Why Choose Us
                </span>
                <h2 class='font-bold text-3xl sm:text-4xl text-dark mb-8'>
                  Make your customers happy by giving services.
                </h2>
                <p class='text-base text-body-color mb-8'>
                  We have been in this business for several years and we are
                  proud of a team which has travelled to every part of Sri Lanka
                  and is savvy about each destination we tour and every hotel we
                  promote. We are happy to have designed so many memorable
                  holidays for travelers from across the world, visitors with
                  different tastes, needs and budgets – all who have enjoyed the
                  tailor made travel packages we have created for every type of
                  holiday maker.
                </p>
                <p class='text-base text-body-color mb-12'>
                  Just as Sri Lanka has diverse destinations, so are the tours
                  we arrange for you to experience them. Our trips are designed
                  to give you flexibility, choice and pace and decide how you
                  want to travel around this Wonderful island we call home. At
                  Views Lanka Tours, we don’t just sell a tour – we design a
                  holiday that’s made for you with the greatest care and
                  attention. Every member on our team has intimate knowledge of
                  every destination we take you to. This makes a big difference
                  to how your tour is designed – because they are people who
                  have actually made the trip, done the hikes, cooked the food,
                  set up camps and checked in and out of each hotel we promote.
                  We have been in this business of travel for so long that we
                  understand the changes which have happened over the years and
                  we have designed our holidays to fit these evolving times.
                </p>
                <a
                  href='javascript:void(0)'
                  class='
                      py-4
                      px-10
                      lg:px-8
                      xl:px-10
                      inline-flex
                      items-center
                      justify-center
                      text-center text-white text-base
                      bg-primary
                      hover:bg-opacity-90
                      font-normal
                      rounded-lg
                      '
                >
                  Travel With Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <section class='w-full bg-white pt-7 pb-7  md:pb-24'>
          <div class='box-border flex flex-col items-center content-center px-8 mx-auto leading-6 text-black border-0 border-gray-300 border-solid md:flex-row max-w-7xl lg:px-16'>
            <div class='box-border relative w-full max-w-md px-4 mt-5 mb-4 -ml-5 text-center bg-no-repeat bg-contain border-solid md:ml-0 md:mt-0 md:max-w-none lg:mb-0 md:w-1/2 xl:pl-10'>
              <img
                src={p6}
                class='p-2 pl-6 pr-5 xl:pl-16 xl:pr-20 '
                data-aos='fade-right'
              />
            </div>

            <div
              class='box-border order-first w-full text-black border-solid md:w-1/2 md:pl-10 md:order-none'
              data-aos='fade-left'
            >
              <h2 class='m-0 text-xl font-semibold leading-tight border-0 border-gray-300 lg:text-3xl md:text-2xl'>
                Qualified Drivers & Staff
              </h2>
              <p class='pt-4 pb-8 m-0 leading-7 text-gray-700 border-0 border-gray-300 sm:pr-12 xl:pr-32 lg:text-lg'>
                Build an atmosphere that creates productivity in your
                organization and your company culture.
              </p>
              <ul class='p-0 m-0 leading-6 border-0 border-gray-300'>
                <li class='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
                  <span class='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-yellow-300 rounded-full'>
                    <span class='text-sm font-bold'>✓</span>
                  </span>{' '}
                  Maximize productivity and growth
                </li>
                <li class='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
                  <span class='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-yellow-300 rounded-full'>
                    <span class='text-sm font-bold'>✓</span>
                  </span>{' '}
                  Speed past your competition
                </li>
                <li class='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
                  <span class='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-yellow-300 rounded-full'>
                    <span class='text-sm font-bold'>✓</span>
                  </span>{' '}
                  Learn the top techniques
                </li>
              </ul>
            </div>
          </div>
          <div class='box-border flex flex-col items-center content-center px-8 mx-auto mt-2 leading-6 text-black border-0 border-gray-300 border-solid md:mt-20 xl:mt-0 md:flex-row max-w-7xl lg:px-16'>
            <div
              class='box-border w-full text-black border-solid md:w-1/2 md:pl-6 xl:pl-32'
              data-aos='fade-right'
            >
              <h2 class='m-0 text-xl font-semibold leading-tight border-0 border-gray-300 lg:text-3xl md:text-2xl'>
                No Hidden Changers
              </h2>
              <p class='pt-4 pb-8 m-0 leading-7 text-gray-700 border-0 border-gray-300 sm:pr-10 lg:text-lg'>
                Save time and money with our revolutionary services. We are the
                leaders in the industry.
              </p>
              <ul class='p-0 m-0 leading-6 border-0 border-gray-300'>
                <li class='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
                  <span class='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-yellow-300 rounded-full'>
                    <span class='text-sm font-bold'>✓</span>
                  </span>{' '}
                  Automated task management workflow
                </li>
                <li class='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
                  <span class='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-yellow-300 rounded-full'>
                    <span class='text-sm font-bold'>✓</span>
                  </span>{' '}
                  Detailed analytics for your data
                </li>
                <li class='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
                  <span class='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-yellow-300 rounded-full'>
                    <span class='text-sm font-bold'>✓</span>
                  </span>{' '}
                  Some awesome integrations
                </li>
              </ul>
            </div>

            <div class='box-border relative w-full max-w-md px-4 mt-10 mb-4 text-center bg-no-repeat bg-contain border-solid md:mt-0 md:max-w-none lg:mb-0 md:w-1/2'>
              <img
                src={flow5}
                class='pl-4 sm:pr-10 xl:pl-10 lg:pr-32'
                data-aos='fade-left'
              />
            </div>
          </div>
          <div class='box-border flex flex-col items-center content-center px-8 mx-auto leading-6 text-black border-0 border-gray-300 border-solid md:flex-row max-w-7xl lg:px-16'>
            <div class='box-border relative w-full max-w-md px-4 mt-5 mb-4 -ml-5 text-center bg-no-repeat bg-contain border-solid md:ml-0 md:mt-0 md:max-w-none lg:mb-0 md:w-1/2 xl:pl-10'>
              <img
                src={flow4}
                class='p-2 pl-6 pr-5 xl:pl-16 xl:pr-20 '
                data-aos='fade-right'
              />
            </div>

            <div
              class='box-border order-first w-full text-black border-solid md:w-1/2 md:pl-10 md:order-none'
              data-aos='fade-left'
            >
              <h2 class='m-0 text-xl font-semibold leading-tight border-0 border-gray-300 lg:text-3xl md:text-2xl'>
                24 Hours Customer Support
              </h2>
              <p class='pt-4 pb-8 m-0 leading-7 text-gray-700 border-0 border-gray-300 sm:pr-12 xl:pr-32 lg:text-lg'>
                Build an atmosphere that creates productivity in your
                organization and your company culture.
              </p>
              <ul class='p-0 m-0 leading-6 border-0 border-gray-300'>
                <li class='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
                  <span class='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-yellow-300 rounded-full'>
                    <span class='text-sm font-bold'>✓</span>
                  </span>{' '}
                  Maximize productivity and growth
                </li>
                <li class='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
                  <span class='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-yellow-300 rounded-full'>
                    <span class='text-sm font-bold'>✓</span>
                  </span>{' '}
                  Speed past your competition
                </li>
                <li class='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
                  <span class='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-yellow-300 rounded-full'>
                    <span class='text-sm font-bold'>✓</span>
                  </span>{' '}
                  Learn the top techniques
                </li>
              </ul>
            </div>
          </div>
          <div class='box-border flex flex-col items-center content-center px-8 mx-auto mt-2 leading-6 text-black border-0 border-gray-300 border-solid md:mt-20 xl:mt-0 md:flex-row max-w-7xl lg:px-16'>
            <div
              class='box-border w-full text-black border-solid md:w-1/2 md:pl-6 xl:pl-32'
              data-aos='fade-right'
            >
              <h2 class='m-0 text-xl font-semibold leading-tight border-0 border-gray-300 lg:text-3xl md:text-2xl'>
                Value For Money
              </h2>
              <p class='pt-4 pb-8 m-0 leading-7 text-gray-700 border-0 border-gray-300 sm:pr-10 lg:text-lg'>
                Save time and money with our revolutionary services. We are the
                leaders in the industry.
              </p>
              <ul class='p-0 m-0 leading-6 border-0 border-gray-300'>
                <li class='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
                  <span class='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-yellow-300 rounded-full'>
                    <span class='text-sm font-bold'>✓</span>
                  </span>{' '}
                  Automated task management workflow
                </li>
                <li class='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
                  <span class='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-yellow-300 rounded-full'>
                    <span class='text-sm font-bold'>✓</span>
                  </span>{' '}
                  Detailed analytics for your data
                </li>
                <li class='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
                  <span class='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-yellow-300 rounded-full'>
                    <span class='text-sm font-bold'>✓</span>
                  </span>{' '}
                  Some awesome integrations
                </li>
              </ul>
            </div>

            <div class='box-border relative w-full max-w-md px-4 mt-10 mb-4 text-center bg-no-repeat bg-contain border-solid md:mt-0 md:max-w-none lg:mb-0 md:w-1/2'>
              <img
                src={flow7}
                class='pl-4 sm:pr-10 xl:pl-10 lg:pr-32'
                data-aos='fade-left'
              />
            </div>
          </div>
          <div class='overflow-hidden box-border flex flex-col items-center content-center px-8 mx-auto leading-6 text-black border-0 border-gray-300 border-solid md:flex-row max-w-7xl lg:px-16'>
            <div class='overflow-hidden box-border relative w-full max-w-md px-4 mt-5 mb-4 -ml-5 text-center bg-no-repeat bg-contain border-solid md:ml-0 md:mt-0 md:max-w-none lg:mb-0 md:w-1/2 xl:pl-10'>
              <img
                src={flow6}
                class='p-2 pl-6 pr-5 xl:pl-16 xl:pr-20'
                data-aos='fade-right'
              />
            </div>

            <div
              class='box-border order-first w-full text-black border-solid md:w-1/2 md:pl-10 md:order-none'
              data-aos='fade-left'
            >
              <h2 class='m-0 text-xl font-semibold leading-tight border-0 border-gray-300 lg:text-3xl md:text-2xl'>
                Guranteed Satisfaction
              </h2>
              <p class='pt-4 pb-8 m-0 leading-7 text-gray-700 border-0 border-gray-300 sm:pr-12 xl:pr-32 lg:text-lg'>
                Build an atmosphere that creates productivity in your
                organization and your company culture.
              </p>
              <ul class='p-0 m-0 leading-6 border-0 border-gray-300'>
                <li class='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
                  <span class='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-yellow-300 rounded-full'>
                    <span class='text-sm font-bold'>✓</span>
                  </span>{' '}
                  Maximize productivity and growth
                </li>
                <li class='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
                  <span class='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-yellow-300 rounded-full'>
                    <span class='text-sm font-bold'>✓</span>
                  </span>{' '}
                  Speed past your competition
                </li>
                <li class='box-border relative py-1 pl-0 text-left text-gray-500 border-solid'>
                  <span class='inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-yellow-300 rounded-full'>
                    <span class='text-sm font-bold'>✓</span>
                  </span>{' '}
                  Learn the top techniques
                </li>
              </ul>
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default Content;
